import SEOHead from "@/components/General/SEOHead";
import News from "@/modules/News/News";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const NewsPage = () => {
  return (
    <>
      <SEOHead />
      <News />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default NewsPage;
